import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { InputProps } from '../input-props';
/**
 * This component is an adapter wrapper for naics input and to be compliant with
 * current filters implementation.
 */
@Component({
  selector: 'miq-filter-naics',
  template: `
    <miq-filter-bar-label [props]="props"></miq-filter-bar-label>
    <miq-record-naics-input
      [recordDetail]="props"
      [currentValue]="props.value"
      selectionMode="checkbox"
      [disabled]="false"
      (currentValueChange)="handleSelection($event)"
      class="detailpage-naicsinput"
    ></miq-record-naics-input>
  `,
  styleUrls: ['./filter-naics.component.scss'],
  standalone: false,
})
export class FilterNaicsComponent implements OnInit {
  @Input() value: string;

  #props: InputProps<string> = null;

  get props() {
    return this.#props;
  }

  @Input() set props(p: InputProps<string>) {
    const nextProps = { ...p, values: [] };
    delete nextProps.options;
    this.#props = nextProps;
  }

  @Output() selection = new EventEmitter();

  constructor(private lookupRefService: LookupRefService) {}

  ngOnInit(): void {
    this.lookupRefService.getNAICSTypes().subscribe(options => (this.#props = { ...this.#props, values: options }));
  }

  handleSelection(change: InputProps) {
    const selection = { [change.field]: change.value };
    this.selection.emit(selection);
  }
}
